import { NavLink, Tooltip } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { useTranslation } from "react-i18next"
import { icons } from "@/components/utils"
import { useAPIResource, useAuth } from "@/hooks"
import { queryKeys, userAPI } from "@/utils"
import classes from "./SideMenu.module.css"

export function NavLanguage({ collapsed }: { collapsed?: boolean }) {
  const { user } = useAuth()
  const { i18n } = useTranslation()
  const [opened, { toggle, close }] = useDisclosure(false)
  const { update } = useAPIResource(userAPI, { invalidate: queryKeys.auth })
  const label = i18n.language == "en" ? "English" : "Русский"

  if (collapsed) {
    return (
      <Tooltip label={label} position="right">
        <NavLink
          label={undefined}
          leftSection={<icons.Language />}
          onClick={toggle}
          classNames={classes}
          data-collapsed={collapsed}
        />
      </Tooltip>
    )
  }

  return (
    <NavLink label={label} leftSection={<icons.Language />} opened={opened} onClick={toggle}>
      <NavLink
        label="English"
        active={i18n.language == "en"}
        onClick={() => {
          i18n.changeLanguage("en")
          if (user) update({ locale: "en", id: user?.id })
          close()
        }}
      />
      <NavLink
        label="Русский"
        active={i18n.language == "ru"}
        onClick={() => {
          i18n.changeLanguage("ru")
          if (user) update({ locale: "ru", id: user?.id })
          close()
        }}
      />
    </NavLink>
  )
}
